import { render, staticRenderFns } from "./DeleteScheduledTemplateType.vue?vue&type=template&id=6a518dfc&"
import script from "./DeleteScheduledTemplateType.vue?vue&type=script&lang=js&"
export * from "./DeleteScheduledTemplateType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports